<template>
    <PageFrameContainer>
        <h2>Documentation will coming soon</h2>
    </PageFrameContainer>
</template>

<script>
    import PageFrameContainer from "../../components/PageFrameContainer";

    export default {
        name: "DocumentationPage",
        components: {PageFrameContainer},
        props: [],
        data: function () {
            return {}
        },
        mounted: function () {
        },
        computed: {},
        methods: {}

    }
</script>

<style scoped lang="scss">
    @import "../../theme/theme";

    h2 {
        margin-top: 2rem;
        font-weight: 300;
        font-size: 2em;
        color: $primary20;

    }
</style>